module.exports = __webpack_public_path__ + "static/media/bogota14.0095c8b9.jpg";